"use client"

import { HotelRoom } from "@/lib/redux/features/hotel/type"

export const useRoomResource = (room?: HotelRoom) => {
  return room?.resource
}
